<template>
  <div class="events-basic-information">
    <bp-input
      v-model="form.name"
      required
      class="mb-6"
      label="Nome do evento"
      placeholder="Prefira um nome que chame a atenção do público"
      description="Atenção! Este é o nome que exibiremos para os seus compradores."
      :limit="64"
    />
    <bp-input
      v-model="form.description"
      :rows="4"
      textarea
      required
      class="mb-6"
      label="Descrição (SEO)"
      placeholder="Explique de forma breve do que se trata o seu evento"
      description="Essa descrição nos ajudará na análise do seu produto."
      :limit="980"
    />

    <div class="row mb-6">
      <div class="col-lg-6 mb-6 mb-lg-0">
        <bp-input
          v-model="form.event_location"
          required
          label="Local"
          placeholder="O lugar onde será feito o evento"
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.event_address"
          required
          label="Endereço do local"
          placeholder="Ex. Rua Andrade Neves, 51"
        />
      </div>
    </div>

    <!-- Using form-group until datepicker component is resolved -->
    <div class="row mb-6">
      <div class="col-lg-6 mb-6 mb-lg-0">
        <form-group
          v-model="form.event_start_at"
          is-date
          readonly
          required
          mode="dateTime"
          id="start-date"
          with-clear-button
          label="Data de início do evento"
          placeholder="Selecione a data inicial"
          :min-date="new Date()"
        />
      </div>
      <div class="col-lg-6">
        <form-group
          v-model="form.event_end_at"
          is-date
          readonly
          required
          mode="dateTime"
          id="start-date"
          with-clear-button
          label="Data de término do evento"
          placeholder="Selecione a data final"
          :min-date="minEndDate"
        />
      </div>
    </div>

    <action-dispatcher action="product/getCategories">
      <bp-select
        v-model="form.category_id"
        required
        label="Categoria do evento"
        placeholder="Selecionar uma categoria"
        description="Escolha a categoria adequada apara que seus compradores encontrem seu produto mais facilmente."
        :options="categories"
      />
    </action-dispatcher>
  </div>
</template>
<script>
import { toComputerDate } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState("product", ["categories"]),
    minEndDate() {
      if (this.form.event_start_at)
        return new Date(toComputerDate(this.form.event_start_at));

      return new Date();
    }
  },
  watch: {
    "form.event_start_at"(v) {
      if (
        this.form.event_end_at &&
        new Date(toComputerDate(v)) >
          new Date(toComputerDate(this.form.event_end_at))
      ) {
        this.$emit("reset-end-date");
      }
    }
  }
};
</script>
